<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/role-permission']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'role-permission_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
